import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"


const componentRouterView = {
    render(c) {
        return c("router-view");
    },
};


const ContratosRoutes = {
    path: "/contratos",
    component: componentRouterView,
    meta: {
        moduleName: "Contratos",
        icon: "file-earmark-text",
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        sistema: 2, 
    },
    children: [
        {
            path: "consulta-contratos",
            name: "ConsultaContratos",
            meta: { description: "Contrato", menu: { name: "Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR } },
            component: () => import("@/modules/contratos/ConsultarContratos.vue"),

        }
    ],
};

export default ContratosRoutes;
